/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { DataBaseService } from '../data-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataEntryExcludingSearchIndex } from '../models/data-entry-excluding-search-index';
import { UserOrgUnitDtoExcludingSearchIndex } from '../models/user-org-unit-dto-excluding-search-index';
import { UserProfileDtoExcludingSearchIndex } from '../models/user-profile-dto-excluding-search-index';
import { UserStateDataEntryValue } from '../models/user-state-data-entry-value';
import { UserStateDataEntryValueExcludingUserFirstLogin } from '../models/user-state-data-entry-value-excluding-user-first-login';

@Injectable({ providedIn: 'root' })
export class UserControllerService extends DataBaseService {

  /**
   * Path part for operation userControllerGetUserDirectManager
   */
  static readonly UserControllerGetUserDirectManagerPath = '/v1/users/direct-manager';

  /**
   * Get current user direct manager
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserDirectManager()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserDirectManager$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<UserOrgUnitDtoExcludingSearchIndex>> {

    const rb = new RequestBuilder(this.rootUrl, UserControllerService.UserControllerGetUserDirectManagerPath, 'get');
    if (params) {
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserOrgUnitDtoExcludingSearchIndex>;
      })
    );
  }
  /**
   * Get current user direct manager
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getUserDirectManager$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserDirectManager(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<UserOrgUnitDtoExcludingSearchIndex> {

    return this.getUserDirectManager$Response(params).pipe(
      map((r: StrictHttpResponse<UserOrgUnitDtoExcludingSearchIndex>) => r.body as UserOrgUnitDtoExcludingSearchIndex)
    );
  }

  /**
   * Path part for operation userControllerGetMyGroups
   */
  static readonly UserControllerGetMyGroupsPath = '/v1/users/my-groups';

  /**
   * Get user profile info
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMyGroups()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMyGroups$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<DataEntryExcludingSearchIndex>>> {

    const rb = new RequestBuilder(this.rootUrl, UserControllerService.UserControllerGetMyGroupsPath, 'get');
    if (params) {
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DataEntryExcludingSearchIndex>>;
      })
    );
  }
  /**
   * Get user profile info
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getMyGroups$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMyGroups(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<DataEntryExcludingSearchIndex>> {

    return this.getMyGroups$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DataEntryExcludingSearchIndex>>) => r.body as Array<DataEntryExcludingSearchIndex>)
    );
  }

  /**
   * Path part for operation userControllerGetUserOrgUnitUsers
   */
  static readonly UserControllerGetUserOrgUnitUsersPath = '/v1/users/my-orgunit';

  /**
   * Returns the list of users inside the org unit of current person related to the signed in user and the parent org unit and all children org units
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserOrgUnitUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserOrgUnitUsers$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<DataEntryExcludingSearchIndex>>> {

    const rb = new RequestBuilder(this.rootUrl, UserControllerService.UserControllerGetUserOrgUnitUsersPath, 'get');
    if (params) {
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DataEntryExcludingSearchIndex>>;
      })
    );
  }
  /**
   * Returns the list of users inside the org unit of current person related to the signed in user and the parent org unit and all children org units
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getUserOrgUnitUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserOrgUnitUsers(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<DataEntryExcludingSearchIndex>> {

    return this.getUserOrgUnitUsers$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DataEntryExcludingSearchIndex>>) => r.body as Array<DataEntryExcludingSearchIndex>)
    );
  }

  /**
   * Path part for operation userControllerGetUserProfile
   */
  static readonly UserControllerGetUserProfilePath = '/v1/users/profile';

  /**
   * Get user profile info
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserProfile()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserProfile$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<UserProfileDtoExcludingSearchIndex>> {

    const rb = new RequestBuilder(this.rootUrl, UserControllerService.UserControllerGetUserProfilePath, 'get');
    if (params) {
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserProfileDtoExcludingSearchIndex>;
      })
    );
  }
  /**
   * Get user profile info
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getUserProfile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserProfile(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<UserProfileDtoExcludingSearchIndex> {

    return this.getUserProfile$Response(params).pipe(
      map((r: StrictHttpResponse<UserProfileDtoExcludingSearchIndex>) => r.body as UserProfileDtoExcludingSearchIndex)
    );
  }

  /**
   * Path part for operation userControllerResetUserState
   */
  static readonly UserControllerResetUserStatePath = '/v1/users/state/reset';

  /**
   * Reset the current user state
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resetUserState()` instead.
   *
   * This method doesn't expect any request body.
   */
  resetUserState$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<UserStateDataEntryValue>> {

    const rb = new RequestBuilder(this.rootUrl, UserControllerService.UserControllerResetUserStatePath, 'put');
    if (params) {
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserStateDataEntryValue>;
      })
    );
  }
  /**
   * Reset the current user state
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resetUserState$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resetUserState(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<UserStateDataEntryValue> {

    return this.resetUserState$Response(params).pipe(
      map((r: StrictHttpResponse<UserStateDataEntryValue>) => r.body as UserStateDataEntryValue)
    );
  }

  /**
   * Path part for operation userControllerGetUserState
   */
  static readonly UserControllerGetUserStatePath = '/v1/users/state';

  /**
   * return the current user state. If a state doesn't exist for current user, create one with default options and return the newly created state
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserState()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserState$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<UserStateDataEntryValue>> {

    const rb = new RequestBuilder(this.rootUrl, UserControllerService.UserControllerGetUserStatePath, 'get');
    if (params) {
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserStateDataEntryValue>;
      })
    );
  }
  /**
   * return the current user state. If a state doesn't exist for current user, create one with default options and return the newly created state
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getUserState$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserState(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<UserStateDataEntryValue> {

    return this.getUserState$Response(params).pipe(
      map((r: StrictHttpResponse<UserStateDataEntryValue>) => r.body as UserStateDataEntryValue)
    );
  }

  /**
   * Path part for operation userControllerUpdateUserState
   */
  static readonly UserControllerUpdateUserStatePath = '/v1/users/state';

  /**
   * return the current user state. If a state doesn't exist for current user, create one with default options and return the newly created state
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUserState()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUserState$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
    body?: UserStateDataEntryValueExcludingUserFirstLogin
  }): Observable<StrictHttpResponse<UserStateDataEntryValue>> {

    const rb = new RequestBuilder(this.rootUrl, UserControllerService.UserControllerUpdateUserStatePath, 'put');
    if (params) {
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserStateDataEntryValue>;
      })
    );
  }
  /**
   * return the current user state. If a state doesn't exist for current user, create one with default options and return the newly created state
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateUserState$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUserState(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
    body?: UserStateDataEntryValueExcludingUserFirstLogin
  }): Observable<UserStateDataEntryValue> {

    return this.updateUserState$Response(params).pipe(
      map((r: StrictHttpResponse<UserStateDataEntryValue>) => r.body as UserStateDataEntryValue)
    );
  }

  /**
   * Path part for operation userControllerActivateUser
   */
  static readonly UserControllerActivateUserPath = '/v1/users/{userId}/activate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `activateUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  activateUser$Response(params: {
    userId: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, UserControllerService.UserControllerActivateUserPath, 'post');
    if (params) {
      rb.path('userId', params.userId, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `activateUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  activateUser(params: {
    userId: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<void> {

    return this.activateUser$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation userControllerDeactivateUser
   */
  static readonly UserControllerDeactivateUserPath = '/v1/users/{userId}/deactivate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deactivateUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  deactivateUser$Response(params: {
    userId: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, UserControllerService.UserControllerDeactivateUserPath, 'post');
    if (params) {
      rb.path('userId', params.userId, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deactivateUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deactivateUser(params: {
    userId: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<void> {

    return this.deactivateUser$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation userControllerResetUserPasswordBySystem
   */
  static readonly UserControllerResetUserPasswordBySystemPath = '/v1/users/{userId}/reset-password';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resetUserPasswordBySystem()` instead.
   *
   * This method doesn't expect any request body.
   */
  resetUserPasswordBySystem$Response(params: {
    userId: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, UserControllerService.UserControllerResetUserPasswordBySystemPath, 'post');
    if (params) {
      rb.path('userId', params.userId, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resetUserPasswordBySystem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resetUserPasswordBySystem(params: {
    userId: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<void> {

    return this.resetUserPasswordBySystem$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
